











































import {Vue, Component, PropSync, Prop} from 'vue-property-decorator';
import {MsgTransports} from "@/store/types";
import {SelectWings} from "wings-ui-components";
import {PartnerSelectionItem} from "@/store/types";
import {PartnerItem} from "@/store/settings/partners/types";
import {Action} from "vuex-class";

@Component({
  components: {SelectWings}
})
export default class PartnerSelectionCard extends Vue {
  @PropSync('itemOptions') item!: any;
  @PropSync('itemSavedOptions') itemSaved!: any;
  @PropSync('partnersOptions') partners!: any[];
  @PropSync('transport') currentTransport!: MsgTransports;
  @Prop({ default: true }) isRequired!: boolean;

  @Action("getPartners") actionGetPartners: any;

  selectedPartners = null;
  partnersList: any = [];

  get params() {
    return { transport: this.currentTransport };
  }

  onDeleteChip(sel: any): void {
    const idx = this.partners.findIndex((item: any) => item.id == sel.id);
    this.partners.splice(idx, 1);
    this.item.partner_ids.splice(idx, 1);
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items;
    // TODO это логику надо будет изменить изменив partner_ids на partners
    const partners: PartnerSelectionItem[] = this.partnersList
        .map((p: PartnerItem) => { return {id: p.id, allowed: false, partner_name: p.name}});
    this.item.partners = partners;
    this.itemSaved.partners = partners;
  }

  onAddPartner(val: number) {
    if (!val || this.partners.find((item: any) => item.id == val)) return;
    const option = this.partnersList.find((item: any) => item.id == val);
    this.item.partner_ids.push(val);
    this.partners.push(option);
  }
}
